module.exports = __webpack_public_path__ + "img/malb.305f6303.png";